import { round } from './math';

export default round;
